import { render, staticRenderFns } from "./Void.vue?vue&type=template&id=a35ba1dc&scoped=true&"
import script from "./Void.vue?vue&type=script&lang=js&"
export * from "./Void.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35ba1dc",
  null
  
)

export default component.exports